import {DatePicker, Form, Input} from 'antd';
import {FormInstance} from 'antd/es/form/Form';
import cn from 'classnames';
import React, {FC} from 'react';

import {SimpleActionButton} from 'components/form/components';
import {ReactComponent as Lock} from 'shared/assets/forms/lock.svg';

import s from './factor-influence-info-service-modal.module.less';

interface IFactorInfluenceInfoServiceModalFormProps {
    form: FormInstance<any>;
    handleFinish: () => void;
}

export const FactorInfluenceInfoServiceModalForm: FC<IFactorInfluenceInfoServiceModalFormProps> = ({
    form,
    handleFinish,
}: IFactorInfluenceInfoServiceModalFormProps) => (
    <Form<any>
        className={cn('form', 'factor-influence-info-service-modal-form')}
        form={form}
        layout="vertical"
        onFinish={handleFinish}
    >
        <div className="form-fields">
            <Form.Item
                className={s['full-width']}
                name="serviceName"
                label="Наименование сервиса"
                required
            >
                <Input
                    disabled
                    suffix={<Lock />}
                />
            </Form.Item>

            <div className={s['factor-influence-info-service-fields']}>
                <div className={s['factor-influence-info-service-fields__title']}>
                    Дополнительные поля
                </div>
                <div className={s['factor-influence-info-service-fields__content']}>
                    <Form.Item
                        className={s['full-width']}
                        name="reportingDate"
                        label="Дата предоставления сведений"
                        required
                    >
                        <DatePicker
                            disabled
                            format="DD.MM.YYYY"
                            className={s['full-width']}
                            suffixIcon={<Lock />}
                        />
                    </Form.Item>
                </div>
            </div>
        </div>

        <SimpleActionButton
            title="Запуск"
            type="primary"
            className={s['full-width']}
            onClick={() => form.submit()}
        />
    </Form>
);

